import React, { useEffect, useRef } from "react";
import { FiArrowUpRight, FiX } from "react-icons/fi";

function SoftwareProjectModal({ project, onClose }) {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!project) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", closeOnEscape);
    closeButtonRef.current?.focus();
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [project, onClose]);

  if (!project) return null;

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <article className="case-modal software-modal" role="dialog" aria-modal="true" aria-labelledby="software-project-title" onMouseDown={(event) => event.stopPropagation()}>
        <button ref={closeButtonRef} className="modal-close" type="button" onClick={onClose} aria-label="Close product brief">
          <FiX />
        </button>
        <p className="system-path">PRODUCT LAB // {project.code}</p>
        <h2 id="software-project-title">{project.name}</h2>
        <span className="development-status"><i />{project.status}</span>
        <div className="case-grid">
          <div>
            <h3>Product Vision</h3>
            <p>{project.vision}</p>
          </div>
          <div>
            <h3>Current Build Focus</h3>
            <p>{project.buildFocus}</p>
          </div>
        </div>
        <h3>Product Stack</h3>
        <div className="tool-row">
          {project.tools.map((tool) => <span key={tool}>{tool}</span>)}
        </div>
        {project.repository ? (
          <a className="modal-repository-link" href={project.repository} target="_blank" rel="noreferrer">
            {project.repositoryLabel}<FiArrowUpRight />
          </a>
        ) : <p className="modal-private-note">Repository access is private while the product is being created.</p>}
      </article>
    </div>
  );
}

export default SoftwareProjectModal;
